import { Component, computed, input, output, signal, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

export type StatusSelectColor = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export type StatusSelectOption = {
  label: string;
  value: string | number;
  icon?: string;
  color?: StatusSelectColor;
};

@Component({
  selector: 'vectronic-status-select',
  templateUrl: './status-select.component.html',
  styleUrls: ['./status-select.component.scss'],
  imports: [
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
    FormsModule,
    NgxMatSelectSearchModule,
  ],
})
export class StatusSelectComponent {
  value = input<string | number | undefined>(undefined);
  options = input.required<StatusSelectOption[]>();
  editable = input<boolean>(false);
  placeholder = input<string>('Select…');
  emptySymbol = input<string>('—');
  searchable = input<boolean>(false);

  valueChange = output<string | number>();

  protected search = signal('');
  private matSelect = viewChild(MatSelect);

  protected selected = computed(
    () => this.options().find((option) => option.value === this.value()) ?? null,
  );

  protected filteredOptions = computed(() => {
    const query = this.search().trim().toLowerCase();
    if (!this.searchable() || !query) return this.options();
    return this.options().filter(
      ({ label, value }) => value === '' || label.toLowerCase().includes(query),
    );
  });

  protected onSelect(value: string | number): void {
    this.valueChange.emit(value);
    const matSelect = this.matSelect();
    if (matSelect && matSelect.value !== this.value()) matSelect.value = this.value();
  }
}
